export default "__VITE_ASSET__oXVmXLUR__"